module.exports = __webpack_public_path__ + "static/media/close.ef74907d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/close.svg
// module id = 141
// module chunks = 0